import React from 'react';
import { Calendar, MapPin, Map, Download } from 'lucide-react';

/**
 * LotesPageHeader - Remate header section with responsive design
 */
const LotesPageHeader = ({
    infoRemate,
    onShowMapModal,
}) => {
    return (
        <div className="mb-6 lg:mb-8 bg-gradient-to-r from-green-600 to-green-500 rounded-xl lg:rounded-2xl p-4 lg:p-8 shadow-2xl">
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 lg:gap-6">
                <div className="flex flex-wrap items-center gap-3 lg:gap-4">
                    <div className="bg-white/10 backdrop-blur-md px-4 lg:px-6 py-2 lg:py-3 rounded-xl border border-white/20">
                        <span className="text-green-200 text-[10px] lg:text-xs font-bold uppercase tracking-wider block mb-0.5 lg:mb-1">Remate</span>
                        <div className="flex items-baseline gap-1">
                            <span className="text-2xl lg:text-3xl font-black text-white tracking-tight">#{infoRemate.numero}</span>
                        </div>
                    </div>

                    <div className="h-8 lg:h-12 w-px bg-white/20 hidden sm:block" />

                    <div>
                        <div className="flex items-center gap-2 text-green-100 mb-0.5 lg:mb-1">
                            {infoRemate.en_curso && (
                                <span className="px-2 py-0.5 rounded text-[9px] lg:text-[10px] font-bold bg-green-500/20 border border-green-400/30 text-green-300 uppercase tracking-wider">
                                    En Vivo
                                </span>
                            )}
                        </div>
                        <h1 className="text-base lg:text-xl font-bold text-white leading-tight">
                            {infoRemate.fecha_formateada || 'Cargando...'}
                        </h1>
                        {infoRemate.lugar && (
                            <div className="flex items-center gap-1 text-green-200 text-xs lg:text-sm mt-0.5 lg:mt-1">
                                <MapPin className="w-3 h-3 lg:w-4 lg:h-4" />
                                <span>{infoRemate.lugar}</span>
                            </div>
                        )}
                    </div>

                    {infoRemate.sello_url && (
                        <>
                            <div className="h-8 lg:h-12 w-px bg-white/20 hidden sm:block" />
                            <img src={infoRemate.sello_url} alt="Sello Remate" className="h-10 lg:h-16 w-auto brightness-0 invert" />
                        </>
                    )}

                    {/* Logo Agro en Punta para remates 315 y 316 */}
                    {(infoRemate.numero === 315 || infoRemate.numero === 316) && (
                        <>
                            <div className="h-8 lg:h-12 w-px bg-white/20 hidden sm:block" />
                            <div className="bg-white/10 backdrop-blur-sm rounded-lg lg:rounded-xl p-1.5 lg:p-2 border border-white/20">
                                <img
                                    src="/web/socios/agro_en_punta.svg"
                                    alt="Agro en Punta"
                                    className="h-12 lg:h-16 w-auto"
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="flex flex-wrap items-center gap-2 lg:gap-4 w-full sm:w-auto">
                    {/* Botones de acción */}
                    <button
                        onClick={onShowMapModal}
                        className="flex-1 sm:flex-none bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white px-4 lg:px-6 py-2 lg:py-3 rounded-lg lg:rounded-xl font-bold transition-all duration-300 hover:shadow-xl flex items-center justify-center gap-2 text-sm lg:text-base"
                    >
                        <Map className="w-4 h-4 lg:w-5 lg:h-5" />
                        <span className="hidden sm:inline">Vista </span>Mapa
                    </button>
                    {infoRemate.catalogo_url && (
                        <a
                            href={infoRemate.catalogo_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex-1 sm:flex-none bg-white text-green-600 hover:bg-white/90 px-4 lg:px-6 py-2 lg:py-3 rounded-lg lg:rounded-xl font-bold transition-all duration-300 hover:shadow-xl flex items-center justify-center gap-2 text-sm lg:text-base"
                        >
                            <Download className="w-4 h-4 lg:w-5 lg:h-5" />
                            <span className="hidden sm:inline">Descargar </span>Catálogo
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LotesPageHeader;
